export type Rgb = readonly [number, number, number];

const NAMED: Record<string, Rgb> = {
  black: [0, 0, 0], white: [255, 255, 255], red: [255, 0, 0], green: [0, 128, 0],
  blue: [0, 0, 255], navy: [0, 0, 128], grey: [128, 128, 128], gray: [128, 128, 128],
};

export function parseColor(text: string): Rgb {
  const t = text.trim().toLowerCase();
  if (t in NAMED) return NAMED[t];
  if (t.includes(',')) {
    const parts = t.split(',').map((s) => Number(s.trim()));
    if (parts.length !== 3 || parts.some((v) => !Number.isInteger(v) || v < 0 || v > 255)) {
      throw new Error(`not an r,g,b colour: ${text}`);
    }
    return [parts[0], parts[1], parts[2]];
  }
  const h = t.replace(/^#/, '');
  if (/^[0-9a-f]{3}$/.test(h)) {
    return [parseInt(h[0] + h[0], 16), parseInt(h[1] + h[1], 16), parseInt(h[2] + h[2], 16)];
  }
  if (/^[0-9a-f]{6}$/.test(h)) {
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }
  throw new Error(`not a colour: ${text}`);
}

export function toHex(c: Rgb): string {
  return '#' + c.map((v) => v.toString(16).padStart(2, '0')).join('');
}

/** Max per-channel absolute difference. Matches Photoshop Magic Wand tolerance. */
export function channelDistance(r: number, g: number, b: number, t: Rgb): number {
  const dr = Math.abs(r - t[0]);
  const dg = Math.abs(g - t[1]);
  const db = Math.abs(b - t[2]);
  return dr > dg ? (dr > db ? dr : db) : dg > db ? dg : db;
}
